// DataPage.tsx
import { useTranslation } from "react-i18next";
import LinkRoutes, { CategorieItem } from "../../components/navigation/LinkRoutes";
import { ERole } from "../../models/enums/role";
import { routes } from "../../routes";
import auth from "../../services/auth/AuthService";

const DataPage = () => {
    const { t } = useTranslation();
    const userRole = auth.user?.role;

    const allCategories: CategorieItem[] = [
        {
            title: t("data.timeTracking"),
            links: [
                { name: t("data.map"), path: routes.dataRoute.interactiveMap },
                { name: t("data.globalDashboard"), path: routes.dataRoute.globalDashboard },
                { name: t("data.timesheets"), path: routes.dataRoute.timesheet },
                { name: t("data.workingRoads"), path: routes.dataRoute.workingRoad },
                { name: t("data.employeeFeedback"), path: routes.dataRoute.employeeFeedback },
                { name: t("data.employeeScans"), path: routes.dataRoute.scans },
            ],
        },
        {
            title: t("data.planning"),
            links: [
                { name: t("data.periodicals"), path: routes.dataRoute.periodics },
                { name: t("data.periodicalsDashboard"), path: routes.dataRoute.periodicsDashboard },
            ],
        },
        {
            title: t("data.formManagement"),
            links: [
                { name: t("data.formCreation"), path: routes.dataRoute.formTemplates },
                { name: t("data.filledForms"), path: routes.dataRoute.filledForms },
            ],
        },
        {
            title: t("data.esl"),
            links: [
                { name: t("data.eslTemplates"), path: routes.dataRoute.eslTemplates },
            ],
        },
    ];

    if (userRole === ERole.Client || userRole === ERole.LimitedClient) {
        const clientCategory: CategorieItem = {
            title: t("data.timeTracking"),
            links: [
                { name: t("data.map"), path: routes.dataRoute.interactiveMap },
                { name: t("data.globalDashboard"), path: routes.dataRoute.globalDashboard },
                { name: t("data.timesheets"), path: routes.dataRoute.timesheet },
            ],
        };
        return <LinkRoutes categories={[clientCategory]} />;
    }

    if (userRole === ERole.Supervisor) {
        const supervisorCategories: CategorieItem[] = [
            {
                title: t("data.timeTracking"),
                links: [
                    { name: t("data.map"), path: routes.dataRoute.interactiveMap },
                    { name: t("data.globalDashboard"), path: routes.dataRoute.globalDashboard },
                    { name: t("data.timesheets"), path: routes.dataRoute.timesheet },
                    { name: t("data.workingRoads"), path: routes.dataRoute.workingRoad },
                    { name: t("data.employeeFeedback"), path: routes.dataRoute.employeeFeedback },
                    { name: t("data.employeeScans"), path: routes.dataRoute.scans },
                ],
            },
            {
                title: t("data.planning"),
                links: [
                    { name: t("data.periodicalsDashboard"), path: routes.dataRoute.periodicsDashboard },
                ],
            },
            {
                title: t("data.formManagement"),
                links: [
                    { name: t("data.filledForms"), path: routes.dataRoute.filledForms },
                ],
            },
        ];
        return <LinkRoutes categories={supervisorCategories} />;
    }

    return <LinkRoutes categories={allCategories} />;
};

export default DataPage;
